import { supabase } from '@/lib/supabase';

/**
 * Le pide a WhatsApp que marque como leídos los mensajes de una conversación — el ✓✓ azul que ve
 * el cliente en SU teléfono.
 *
 * 🪤 EL VISTO SE DISPARABA SÓLO AL ABRIR LA CONVERSACIÓN. Vivía dentro del cargador del hilo, que
 * corre al abrir o cambiar de chat. Un mensaje que entra mientras el operador YA está mirando esa
 * conversación no pasaba por ahí y nada lo marcaba: el cliente veía sus mensajes en gris para
 * siempre aunque del otro lado los estuvieran leyendo en vivo. Reportado el 2026-09-07.
 *
 * 🪤 SE AGRUPA POR CONVERSACIÓN Y SE ESPERA UN POCO. Cinco mensajes seguidos llegan como cinco
 * eventos casi juntos; una llamada por cada uno serían cinco viajes al servidor y cinco a Meta para
 * decir lo mismo. Meta marca un mensaje Y TODOS LOS ANTERIORES de la conversación, así que una sola
 * llamada al final de la ráfaga alcanza y sobra.
 *
 * 🪤 Y VIVE ACÁ Y NO EN EL HOOK a propósito: no es carga de datos para pintar la pantalla, es un
 * aviso al servidor. Mezclarlo con la carga del hilo fue justamente lo que lo dejó atado al momento
 * de abrir el chat.
 */
const VISTOS_EN_VUELO = new Map<string, number>();

export function marcarVistoEnWhatsApp(conversationId: string): void {
  const pendiente = VISTOS_EN_VUELO.get(conversationId);
  if (pendiente) clearTimeout(pendiente);

  const temporizador = setTimeout(async () => {
    VISTOS_EN_VUELO.delete(conversationId);
    try {
      const { data } = await supabase.auth.getSession();
      const token = data.session?.access_token;
      if (!token) return;
      await supabase.functions.invoke('whatsapp-read-receipt', {
        body: { conversation_id: conversationId },
      });
    } catch {
      /* El visto es cortesía, no correo certificado: si falla, no se le dice nada a nadie. */
    }
  }, 400) as unknown as number;

  VISTOS_EN_VUELO.set(conversationId, temporizador);
}
